module.exports = __webpack_public_path__ + "static/toxicodb-logo-64f6a97c43f01d62751f193f45d3e291.png";